export default __webpack_public_path__ + "static/media/drag-icon.2eb08bcc.svg";